module.exports = __webpack_public_path__ + "img/success.97006ef8.svg";